import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import { ErrorBoundary, SpritesSheet } from '~/components';
import Canvas from './Canvas';
import { useFetch, useFetchFonts, useFetchLogoClbSpriteSheet, useFetchSpriteSheet } from '~/hooks';
import { DeviceType, StatusFetch } from '~/enum/common';
import { EventService } from '~/services/event';
import { LeagueEvent } from '~/enum/event';
import { BannerVoltaModel } from '~/classes';
import { getThemeColor } from '~/utils/common';
const BannerVolta = ({ themeId, onClick, device = DeviceType.Mobile, }) => {
    const BannerVoltaModelSingleton = useRef(null);
    const isMobile = device === DeviceType.Mobile;
    const { data, status: fetchSpriteSheetStatus } = useFetchSpriteSheet(isMobile ? SpritesSheet.voltaBanner.texture : SpritesSheet.voltaBannerDesktop.texture, isMobile ? SpritesSheet.voltaBanner.image : SpritesSheet.voltaBannerDesktop.image, isMobile ? 2 : 1);
    const { status: fetchFontsStatus } = useFetchFonts();
    const { data: spriteCLB, status: fetchSpriteSheetLogoCLBStatus } = useFetchLogoClbSpriteSheet(SpritesSheet.logoCLB.texture, SpritesSheet.logoCLB.image);
    const { data: events, isLoading } = useFetch(EventService.getEvent);
    const event = useMemo(() => {
        var _a, _b;
        return (_b = (_a = events === null || events === void 0 ? void 0 : events[0]) === null || _a === void 0 ? void 0 : _a[LeagueEvent.EventList]) === null || _b === void 0 ? void 0 : _b[0];
    }, [events]);
    const renderCanvasElement = useMemo(() => {
        var _a;
        try {
            if (!data || !spriteCLB || themeId === -99) {
                return _jsx("div", { children: "No data available" });
            }
            if (!BannerVoltaModelSingleton.current) {
                BannerVoltaModelSingleton.current = new BannerVoltaModel(data.textureData, data.spriteImage, spriteCLB.textureData, spriteCLB.spriteImage);
            }
            const themeColor = getThemeColor(themeId);
            (_a = BannerVoltaModelSingleton.current) === null || _a === void 0 ? void 0 : _a.setupDeviceAndTheme(device, themeColor);
            return (_jsx(Canvas, { bannerVoltaModelSingleton: BannerVoltaModelSingleton, event: event, device: device, onClick: onClick, callbackReset: () => {
                    BannerVoltaModelSingleton.current = null;
                } }));
        }
        catch (error) {
            throw error;
        }
    }, [data, spriteCLB, event, themeId, onClick, device]);
    if (fetchSpriteSheetStatus === StatusFetch.LOADING ||
        fetchFontsStatus === StatusFetch.LOADING ||
        fetchSpriteSheetLogoCLBStatus === StatusFetch.LOADING ||
        isLoading) {
        return _jsx("div", { children: "Loading..." });
    }
    return (_jsx(ErrorBoundary, { fallback: _jsx("div", { className: "banner-placeholder", children: "Banner hi\u1EC7n kh\u00F4ng kh\u1EA3 d\u1EE5ng" }), children: renderCanvasElement }));
};
export default BannerVolta;
